import { styled } from "@mui/material";

export const TeamMemberComponent = styled("div")(() => ({
  display: "flex",
  justifyContent: "space-between",
  alingItems: "center",
  gap: "4px",
  width: "100%",
}));
